import { makeStyles } from '@alpha/ui-lib/theme';

export const useStyles = makeStyles(
  () => ({
    detailsContainer: {
      margin: '24px 0px',
      border: '1px #EAEAEA solid',
      borderRadius: '10px',
      padding: '16px',
      fontWeight: 600,
      fontSize: '16px',
      '& .datePicker .MuiInput-input': {
        borderRadius: '4px',
      },
      width: '836px',
    },
    placeholder: {
      color: 'rgb(154, 154, 154)',
      fontWeight: 400,
    },
    dropdown: {
      borderRadius: '4px',
      background: '#F7F7F7',
      opacity: '100%',
      width: '353px',
      height: '47px',
      color: '#343434',
      fontSize: '14px',
      '& .MuiSelect-select.MuiSelect-select': {
        background: '#F7F7F7',
        paddingLeft: '16px',
      },
      '& #split-select #currency-select': {
        minWidth: '36px',
        borderRadius: '4px',
        background: '#F7F7F7',
        color: '#000000',
        padding: '10.2px 20px 14.5px 16px',
      },
    },
    evenSplitAmount: {
      border: '1px solid #E4E4E7 ',
      borderRadius: '4px',
      width: '548px',
      height: '47px',
    },
    disabledEvenSplitAmount: {
      border: '1px solid #E4E4E740',
      borderRadius: '4px',
      width: '548px',
      height: '47px',
    },
    tooltip: {
      backgroundColor: '#222222',
      color: '#FFFFFF',
      padding: '4px 8px',
      borderRadius: '4px',
      fontSize: '12px',
    },
  }),
  { name: 'MassDrawdownDetails' },
);

export default useStyles;
